import JobsIcon from '@components/icons/Jobs.svg';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useModalContext } from '@providers/ModalProvider';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { ToolbarActionButton } from '@components/core-ui/form-elements/buttons/Button/variations/ToolbarActionButton';

export const ResubmitButton = () => {
  const { job, manualReload } = usePageContext();
  const { openModal, closeModal } = useModalContext();

  const showResubmitJobModal = (id: string) => {
    openModal(ModalNamesEnum.AdminResubmitJobModal, {
      onSuccess: () => {
        closeModal();
        manualReload();
      },
      id,
      job,
    });
  };

  if (!job || !job.status) {
    return null;
  }

  return (
    <ToolbarActionButton
      className="w-[105px]"
      type="button"
      title="Resubmit"
      onClick={() => showResubmitJobModal(job.id)}
    >
      <JobsIcon />
      Resubmit
    </ToolbarActionButton>
  );
};
